// add to list functions start
function getQtyLimit() { return parseInt(localStorage.getItem("minimumChoice")) || 0; }
const QtyLimit = getQtyLimit();
// Option selection start 
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.block-content .selection--button')?.forEach(element => {
    element.addEventListener('click', () => {
      // Clear previous selections when user picks a new size/style
      localStorage.removeItem("selectedStyle");
      localStorage.removeItem("selectedStyleProduct");
      localStorage.removeItem("selectedProductgID");
      localStorage.removeItem("minimumChoice");
      localStorage.removeItem("selectedStyleAddOn");
      localStorage.removeItem("selectedProducts");
        // document.querySelectorAll('.block-content .selection--button').forEach(element => {
        //   element.classList.remove("selected");
        // });
               // You can add additional functionality here
        if(element.closest('.style-block') != null){
          document.querySelectorAll('.block-content .style-block-content.selection--button').forEach(element => {
            element.classList.remove("selected");
          });
          const text_lowercase =  element.getAttribute('data-text').toLowerCase();
          document.querySelectorAll(`.block-content .diet-block-content.selection--button`).forEach(element => {
            element.style.display = 'none';
          });
          document.querySelectorAll(`.block-content .diet-block-content.selection--button[data-parent-style="${text_lowercase}"]`).forEach(element => {
            element.style.display = 'flex';
          });
          if(element.querySelector('.style-title').textContent == 'Bag' || element.querySelector('.style-title').textContent == 'Bowl'){
            const btnDiv = document.querySelector('.button-wrapper');
            if ( btnDiv && btnDiv.offsetParent !== null) {
              btnDiv.style.display = 'none';
            }
            document.querySelector('.weight-block').style.display = 'flex';
            document.querySelector('.weight-block').scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }else{
            const weightDiv = document.querySelector('.weight-block');
            // if ( weightDiv && weightDiv.offsetParent !== null) {}
            weightDiv.style.display = 'flex';
            document.querySelector(`.block-content .diet-block-content.selection--button[data-variant-id="${element.getAttribute('data-variant-id')}"]`).click(); 
            document.querySelector('.button-wrapper').style.display = 'flex';
            // document.querySelector('.button-wrapper').scrollIntoView({
            //   behavior: "smooth",
            //   block: "start",
            // });
          } 
          localStorage.setItem("selectedStyle", element.getAttribute('data-text').toLowerCase());
          localStorage.setItem("selectedStyleAddOn", element.getAttribute('data-addon'));
        }
        if(element.closest('.weight-block') != null){
            document.querySelectorAll('.block-content .diet-block-content.selection--button').forEach(element => {
              element.classList.remove("selected");
            });
            document.querySelector('.button-wrapper').style.display = 'flex';
            // document.querySelector('.button-wrapper').scrollIntoView({
            //   behavior: "smooth",
            //   block: "start",
            // });
        }
        if(element.getAttribute('data-variant-id')) localStorage.setItem("selectedStyleProduct", element.getAttribute('data-variant-id'));
        if(element.getAttribute('data-option-count')) localStorage.setItem("minimumChoice", element.getAttribute('data-option-count'));
        const randomText = Math.floor(100000000 + Math.random() * 900000000);
        const gID = randomText;
        localStorage.setItem("selectedProductgID", gID);
        element.classList.add("selected");
    });
  });
  // mobile view custom cart list view clickevents 
  let mvClContent = document.getElementById('mv-cl-content');
  document.getElementById('cart-list-mobile')?.addEventListener('click', function() {
      var productList = document.getElementById('custom-view_cart').innerHTML;
      mvClContent.classList.add('active','custom-view_cart');
      setTimeout(() => {  
        mvClContent.innerHTML = productList;
        document.body.classList.add('no-scroll');
        mobile_cartListView();
      }, 500);
  });
  checkMaximumLimit();
});
function mobile_cartListView(){
  let mvClContent = document.getElementById('mv-cl-content');
  document.querySelector('.cvc-header-close-wrap .cvc-close-icon').addEventListener('click', function() {
    mvClContent.classList.remove('active', 'custom-view_cart');
    mvClContent.innerHTML = '';
    document.body.classList.remove('no-scroll');
  });
  attachRemoveItemListeners();
  // console.log('btnnnn',document.querySelector("#continueToCart button"));
  let selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || []; 
  totalItemsAdded = selectedProducts.reduce((total, product) => total + product.quantity,0);
  if (totalItemsAdded >= getQtyLimit()) {
    showAddAllToCartButton();
  }
  else {
    hideAddAllToCartButton();
  }
  document.querySelector("#mv-cl-content #continueToCart button").addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();

    addMainProductAndBatch(selectedProducts);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const savedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  savedProducts.forEach((product) => {
    const productCard = document.querySelector(
      `.grid__item[data-variant-id="${product.variantId}"]`
    );

    if (productCard) {
      const addToCartBtn = productCard.querySelector(".custom_addCart");
      const quantityControls = productCard.querySelector(".custom_cart-quantity");
      const quantityInput = productCard.querySelector(".quantity__input");
      const increaseBtn = productCard.querySelector(".quantity__button[name='plus']");
      // Disable + button if quantity >= inventory
      const inventory = parseInt(addToCartBtn.getAttribute("data-inventory"));
      if (product.quantity == inventory && increaseBtn) {
        increaseBtn.classList.add('disabled');
      } else if (increaseBtn) {
        increaseBtn.classList.remove('disabled');
      }

      if (addToCartBtn) addToCartBtn.classList.add('hide_btn');
      if (quantityControls) quantityControls.classList.remove('hide_btn');

      quantityInput.value = product.quantity;
      setupQuantityButtons(productCard, product.variantId);
    }
    updateCartContainer(
      product.variantId,
      product.title,
      product.image,
      product.price,
      product.quantity,
      product.productId,
      product.productTag
    );
  });

  totalItemsAdded = savedProducts.reduce(
    (total, product) => total + product.quantity,
    0
  );
  checkAndDisableButtons(getQtyLimit());

  if (totalItemsAdded >= getQtyLimit()) {
    showAddAllToCartButton();
  } else {
    hideAddAllToCartButton();
  }

  updateChoiceStatus(getQtyLimit());
});

// When a size button is clicked it dispatches this event — re-sync everything
document.addEventListener('pnm:size-selected', function() {
  var limit = getQtyLimit();
  checkAndDisableButtons(limit);
  updateChoiceStatus(limit);
  hideAddAllToCartButton();
  checkMaximumLimit();
});

fetch("/cart.js")
.then((response) => response.json())
.then((cartData) => {
  document.querySelectorAll(".grid__item").forEach((productCard) => {
    const addToCartBtn = productCard.querySelector(
      ".custom_addCart"
    );

    if (!addToCartBtn) {
      console.warn("No add-to-cart button found for product:", productCard);
      return;
    }

    if (
      addToCartBtn.getAttribute("data-sold-out-message") === true
    ) {
      return;
    }

    const variantId = addToCartBtn.getAttribute("data-variant-id");
    const productTag = productCard.getAttribute("data-product-tags");
    const quantityInput = productCard.querySelector(".quantity__input");
    addToCartBtn.addEventListener("click", () => {
      // Always start with 1 when first adding a product
      const quantity = 1;
      if (quantityInput) quantityInput.value = 1;
      const title = productCard
        .querySelector(".card__heading a")
        .textContent.trim();
      const image = productCard
        .querySelector(".card__media img")
        .getAttribute("srcset");
      let priceElement = productCard.querySelector(".price__container span.price-item.price-item--regular");

      // If the original price element is not found, look for the `.money` class
      if (!priceElement) {
        priceElement = productCard.querySelector(".price__container .price-item price-item--sale");
      }
      
      // Extract the price value if the element exists
      let price = 0;
      if (priceElement) {
        const priceText = priceElement.textContent.trim();
        console.log(`Initial add to cart price text: "${priceText}"`);
        // Extract numeric value - handle different price formats
        const numericValue = parseFloat(priceText.replace(/[^\d.,-]/g, "").replace(",", "."));
        console.log(`Extracted numeric value: ${numericValue}`);
        
        // Check if the price is already in dollars or needs conversion from cents
        if (numericValue > 100) {
          // Likely in cents, convert to dollars
          price = numericValue / 100;
          console.log(`Converted from cents to dollars: ${price}`);
        } else {
          // Likely already in dollars
          price = numericValue;
          console.log(`Using as dollars: ${price}`);
        }
      }

   
      addSelectedProductToLocalStorage(
        variantId,
        quantity,
        title,
        image,
        parseFloat(parseFloat(price).toFixed(2)),
        productTag
      );
      addToCartBtn.classList.add('hide_btn');
      const quantityControls =
        productCard.querySelector(".custom_cart-quantity");
      if (quantityControls) quantityControls.classList.remove('hide_btn');
    //   updateTotalItemsAndCheckButtons(0);
      // Disable plus icon if inventory is 1 and product is added to cart
      const check_productCard = document.querySelector(`.grid__item[data-variant-id="${variantId}"]`);
      const increaseBtn = check_productCard.querySelector(".quantity__button[name='plus']");
      const increase_val = check_productCard.querySelector(".quantity__input").value;
      if (increase_val == check_productCard.querySelector('.custom_addCart').getAttribute('data-inventory')) {
        if (increaseBtn)increaseBtn.classList.add('disabled');
      }else{
        if (increaseBtn) increaseBtn.classList.remove('disabled');
      }
    });
    setupQuantityButtons(productCard, variantId);
  });
})
.catch((error) => {
  console.error("Error fetching cart data:", error);
});
function addSelectedProductToLocalStorage(
  variantId,
  quantity,
  title,
  image,
  price,
  productTag
) {
  let productData = null;
  let variant = null;
  let productId = null;

  // Loop through productsData to find the correct product and variant
  for (const id in window.productsData) {
    const product = window.productsData[id];
    variant = product.variants.find((v) => v.variantId === variantId);
    if (variant) {
      productData = product;
      productId = id;
      break;
    }
  }
  if (!productData || !variant) {
    console.error(`No product or variant found for variantId: ${variantId}`);
    return;
  }
  
  // Get the correct price from Shopify admin data (variant.price is in cents)
  const priceInCents = parseInt(variant.price);
  const priceInDollars = priceInCents / 100;
  
  console.log(`Admin price in cents: ${priceInCents}`);
  console.log(`Admin price in dollars: ${priceInDollars}`);
  
  // Use the admin price instead of the frontend extracted price
  price = priceInDollars;
  
  const formattedPrice = parseFloat(price).toFixed(2);
  console.log(`Final price to store: ${price}, formatted: ${formattedPrice}`);
  let selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const existingProduct = selectedProducts.find(
    (product) => product.variantId === variantId
  );
  if (existingProduct) {
    existingProduct.quantity += quantity;
  } else {
    selectedProducts.push({
      variantId,
      productId,
      quantity,
      title,
      image,
      price: price, // Store the actual numeric price, not the formatted string
      productTag,
    });
  }
  const totalItemsAdded = selectedProducts.reduce(
    (total, product) => total + product.quantity,
    0
  );
  localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
  updateCartContainer(
    variantId,
    title,
    image,
    price, // Use the numeric price instead of formatted string
    existingProduct ? existingProduct.quantity : quantity,
    productId,
    productTag
  );
  updateChoiceStatus(localStorage.getItem("minimumChoice"));
  checkAndDisableButtons(getQtyLimit());
  updatePremiumAddOnCharges();
  // updateTotalPriceDisplay();
  checkMaximumLimit();
  
  // Update cart count in header
  updateCartCountInHeader();
  
  // IMMEDIATELY ensure SVG is present when product is added
  setTimeout(ensureCartIconSVG, 10);
  setTimeout(ensureCartIconSVG, 50);
  setTimeout(ensureCartIconSVG, 100);
}

function updatePremiumAddOnCharges() {
  const selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  let totalPremiumCharges = 0;

  selectedProducts.forEach((product) => {
    if (product.productTag && product.productTag.includes("premium-")) {
      const premiumTags = product.productTag
        .split(",")
        .map((tag) => tag.trim())
        .filter((tag) => tag.startsWith("premium-"));
      premiumTags.forEach((tag) => {
        const premiumValue = parseFloat(tag.replace("premium-", ""));
        if (!isNaN(premiumValue)) {
          totalPremiumCharges += premiumValue * product.quantity;
        }
      });
    }
  });

  const premiumAddOnElement = document.getElementById("premium-add-on");
  if (premiumAddOnElement) {
    if (totalPremiumCharges > 0) {
      premiumAddOnElement.style.display = "block";
      premiumAddOnElement.querySelector(
        "span"
      ).textContent = `$${totalPremiumCharges.toFixed(2)}`;
    } else {
      premiumAddOnElement.style.display = "none";
    }
  }
}

function setupQuantityButtons(productCard, variantId) {
  const decreaseBtn = productCard.querySelector(
    ".quantity__button[name='minus']"
  );
  const increaseBtn = productCard.querySelector(
    ".quantity__button[name='plus']"
  );
  const quantityInput = productCard.querySelector(".quantity__input");

  let productData = null;
  let variant = null;

  for (const productId in window.productsData) {
    const product = window.productsData[productId];
    variant = product.variants.find((v) => v.variantId === variantId);
    if (variant) {
      productData = product;
      break;
    }
  }

  if (!productData || !variant) {
    // console.error(`No product or variant found for variantId: ${variantId}`);
    return;
  }
  let selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const productTag = productCard.getAttribute("data-product-tags");
  if (!decreaseBtn.hasAttribute("listener")) {
    decreaseBtn.addEventListener("click", () => {
      let quantity = parseInt(quantityInput.value, 10) || 1;
      if (quantity > 1) {
        quantity--;
        quantityInput.value = quantity;
        updateProductQuantityInLocalStorage(variantId, quantity);
        // updateTotalItemsAndCheckButtons(-1);
        // updateTotalPriceDisplay();

        const productId = productCard.getAttribute("data-product-id");

      // Updated price extraction to handle both original and currency-converted elements
      const priceElement =
        productCard.querySelector(
          ".price__container span.price-item.price-item--regular"
        ) ||
        productCard.querySelector(
          ".price__container .price-item price-item--sale"
        );
      let price = 0;
      if (priceElement) {
        const priceText = priceElement.textContent.trim();
        // Extract numeric value and convert from cents to dollars
        const numericValue = parseFloat(priceText.replace(/[^\d.,-]/g, "").replace(",", "."));
        price = numericValue / 100; // Convert from cents to dollars
      }

        updateCartContainer(
          variantId,
          productCard.querySelector(".card__heading a").textContent.trim(),
          productCard.querySelector(".card__media img").getAttribute("srcset"),
          price,
          quantity,
          productId,
          productTag
        );
        updatePremiumAddOnCharges();
        updateSideCartQuantity(variantId, quantity);
      } else if (quantity === 1) {
        removeProductFromLocalStorage(variantId);
        quantityInput.value = 1;
        removeProductFromCartContainer(variantId);
        updatePremiumAddOnCharges();
      }
      // Disable plus icon if inventory is 1 and product is added to cart
      const check_productCard = document.querySelector(
        `.grid__item[data-variant-id="${variantId}"]`
      );
      const increaseBtn = check_productCard.querySelector(
        ".quantity__button[name='plus']"
      );
      const increase_val =
        check_productCard.querySelector(".quantity__input").value;
      if (
        increase_val ==
        check_productCard
          .querySelector(".custom_addCart")
          .getAttribute("data-inventory")
      ) {
        if (increaseBtn) increaseBtn.classList.add("disabled");
      } else {
        if (increaseBtn) increaseBtn.classList.remove("disabled");
      }
    });
    decreaseBtn.setAttribute("listener", "true");
  }

  if (!increaseBtn.hasAttribute("listener")) {
    increaseBtn.addEventListener("click", () => {
      let quantity = parseInt(quantityInput.value, 10) || 1;
      quantity++;
      quantityInput.value = quantity;

      const title = productCard
        .querySelector(".card__heading a")
        .textContent.trim();
      const image = productCard
        .querySelector(".card__media img")
        .getAttribute("srcset");
      let priceElement = productCard.querySelector(
        ".price__container span.price-item.price-item--regular"
      );

      // If the original price element is not found, look for the `.money` class
      if (!priceElement) {
        priceElement = productCard.querySelector(
          ".price__container .price-item price-item--sale"
        );
      }

      // Extract the price value if the element exists
      let price = 0;
      if (priceElement) {
        const priceText = priceElement.textContent.trim();
        // Extract numeric value and convert from cents to dollars
        const numericValue = parseFloat(priceText.replace(/[^\d.,-]/g, "").replace(",", "."));
        price = numericValue / 100; // Convert from cents to dollars
      }

      const existingProduct = selectedProducts.find(
        (product) => product.variantId === variantId
      );

      if (!existingProduct) {
        addSelectedProductToLocalStorage(
          variantId,
          1,
          title,
          image,
          parseFloat(parseFloat(price).toFixed(2)),
          productTag
        );
        // updateTotalItemsAndCheckButtons(1);
        // updateTotalPriceDisplay();
      } else {
        updateProductQuantityInLocalStorage(variantId, quantity);
        // updateTotalItemsAndCheckButtons(1);
        // updateTotalPriceDisplay();
      }
      updateCartContainer(variantId, title, image, price, quantity, productTag);
      updatePremiumAddOnCharges();
      updateSideCartQuantity(variantId, quantity);
      // Disable plus icon if inventory is 1 and product is added to cart
      const check_productCard = document.querySelector(
        `.grid__item[data-variant-id="${variantId}"]`
      );
      const increaseBtn = check_productCard.querySelector(
        ".quantity__button[name='plus']"
      );
      const increase_val =
        check_productCard.querySelector(".quantity__input").value;
      if (
        increase_val ==
        check_productCard
          .querySelector(".custom_addCart")
          .getAttribute("data-inventory")
      ) {
        if (increaseBtn) increaseBtn.classList.add("disabled");
      } else {
        if (increaseBtn) increaseBtn.classList.remove("disabled");
      }
    });
    increaseBtn.setAttribute("listener", "true");
  }
}
function updateCartContainer(
  variantId,
  title,
  image,
  price,
  quantity,
  productId,
  productTag
) {
  const cartContainerDesktop = document.getElementById("cart-items");
  // Standardize both basePrice and price by handling commas and converting from cents if necessary
  let price_vari = ``;
  if (productTag?.includes("premium-")) {
    const premiumValue = productTag
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag.startsWith("premium-"))
      .map((tag) => tag.replace("premium-", ""));
    const qtyBasePremiumValue = quantity * premiumValue;
    price_vari = `<div class="price-wrap"><span class="premium-price" data-premium-Value="${premiumValue}">$${qtyBasePremiumValue}</span></div>`;
  } else {
    const totalPrice = price * quantity;
    price_vari = `<div class="price-wrap"><span class="lp-price" data-base-price="${price}">Free</span></div>`;
  }
  const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
    <path d="M1 4H17M13 4L12.7294 3.18807C12.4671 2.40125 12.3359 2.00784 12.0927 1.71698C11.8779 1.46013 11.6021 1.26132 11.2905 1.13878C10.9376 1 10.523 1 9.69357 1H8.30643C7.47705 1 7.06236 1 6.70951 1.13878C6.39792 1.26132 6.12208 1.46013 5.90729 1.71698C5.66405 2.00784 5.53292 2.40125 5.27064 3.18807L5 4M15 4V14.2C15 15.8802 15 16.7202 14.673 17.362C14.3854 17.9265 13.9265 18.3854 13.362 18.673C12.7202 19 11.8802 19 10.2 19H7.8C6.11984 19 5.27976 19 4.63803 18.673C4.07354 18.3854 3.6146 17.9265 3.32698 17.362C3 16.7202 3 15.8802 3 14.2V4M11 8V15M7 8V15" stroke="#1F1F1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
        `;
  const createCartItemHTML = () => `
    <div class="img-wrap">
          <img src="${image}" alt="${title}" width="80">
      </div>
      <div class="cart-item-details">
          <div class="lp-title">${title}</div>
          <div class="qty-price-wrap">
              <div class="custom-qty-btn-wrap">
                  <div class="custom_cart-quantity cart-quantity">
                      <button class="quantity__button cart-quantity-minus" data-variant-id="${variantId}" name="minus" type="button">
                          <span class="visually-hidden">Decrease quantity</span>
                          <span class="svg-wrapper">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                  <path d="M3.5 7H10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                          </span>
                      </button>
                      <input class="quantity__input cart-quantity-input" data-variant-id="${variantId}" type="number" value="${quantity}" min="1" aria-label="Quantity">
                      <button class="quantity__button cart-quantity-plus" data-variant-id="${variantId}" name="plus" type="button">
                          <span class="visually-hidden">Increase quantity</span>
                          <span class="svg-wrapper">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                  <path d="M7 3.5V10.5M3.5 7H10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                          </span>
                      </button>
                  </div>
              </div>
              ${price_vari}
          </div>
      </div>
      <div class="cartQuantityRemove">
          <div class="remove-item-btn" data-variant-id="${variantId}">${svgIcon}</div>
      </div>
  `;

  if (!cartContainerDesktop) return;

  let cartItem = cartContainerDesktop.querySelector(
    `li[data-variant-id="${variantId}"]`
  );

  if (!cartItem) {
    cartItem = document.createElement("li");
    cartItem.setAttribute("data-variant-id", variantId);
    cartItem.setAttribute("data-product-id", productId);
    cartItem.setAttribute("data-product-tags", productTag);
    cartItem.className = "cart-item";
    cartItem.innerHTML = createCartItemHTML(quantity);
    cartContainerDesktop.appendChild(cartItem);
  } else {
    const quantityInput = cartItem.querySelector(".cart-quantity-input");
    const has_premiumPrice = cartItem.querySelector(".premium-price");
    if (has_premiumPrice) {
      const final_premium =
        quantity * has_premiumPrice.getAttribute("data-premium-Value");

      has_premiumPrice.textContent = `$${final_premium}`;
    }
    if (quantityInput) {
      quantityInput.value = quantity;
    }
  }
  attachRemoveItemListeners();
  updateChoiceStatus(localStorage.getItem("minimumChoice"));
  updatePremiumAddOnCharges();
  const selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const totalItemsAdded = selectedProducts.reduce(
    (total, product) => total + product.quantity,
    0
  );
  if (totalItemsAdded >= getQtyLimit()) {
    showAddAllToCartButton();
  } else {
    hideAddAllToCartButton();
  }
  checkMaximumLimit();
  
  // Update cart count in header
  updateCartCountInHeader();
  
  // IMMEDIATELY ensure SVG is present when cart is updated
  setTimeout(ensureCartIconSVG, 10);
  setTimeout(ensureCartIconSVG, 50);
  setTimeout(ensureCartIconSVG, 100);
}
function showAddAllToCartButton() {
  const addAllToCartBtnDesktop = document.querySelector(
    "#continueToCart button"
  );
  // const addAllToCartBtnMobile = document.querySelector(
  //   "#continueToCartMobile button"
  // );
  // const priceDisplayDesktop = document.getElementById("priceDisplay");
  // const priceDisplayMobile = document.getElementById("priceDisplayMobile");
  // const ButtonProductName = localStorage.getItem("productButtonName");
  // console.log(ButtonProductName);
  if (addAllToCartBtnDesktop) {
    addAllToCartBtnDesktop.style.display = "flex";

    // if (priceDisplayDesktop) {
    //   priceDisplayDesktop.style.display = "none";
    //   console.log("Hiding price display on desktop.");
    // }

    // let selectedProducts =
    //   JSON.parse(localStorage.getItem("selectedProducts")) || [];

    if (!addAllToCartBtnDesktop.hasAttribute("listener")) {
      addAllToCartBtnDesktop.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        let selectedProducts =
          JSON.parse(localStorage.getItem("selectedProducts")) || [];
        addMainProductAndBatch(selectedProducts);
      });
      addAllToCartBtnDesktop.setAttribute("listener", "true");
    }
  }

  // if (addAllToCartBtnMobile) {
  //   addAllToCartBtnMobile.style.display = "flex";
  //   console.log(
  //     "Selection limit reached. Showing 'Add All to Cart' button on mobile."
  //   );

  //   if (priceDisplayMobile) {
  //     priceDisplayMobile.style.display = "none";
  //     console.log("Hiding price display on mobile.");
  //   }

  //   let selectedProducts =
  //     JSON.parse(localStorage.getItem("selectedProducts")) || [];

  //   if (!addAllToCartBtnMobile.hasAttribute("listener")) {
  //     addAllToCartBtnMobile.addEventListener("click", (event) => {
  //       event.preventDefault();
  //       event.stopPropagation();

  //       let selectedProducts =
  //           JSON.parse(localStorage.getItem("selectedProducts")) || [];

  //       console.log("Adding the following products:", selectedProducts);

  //       addMainProductAndBatch(selectedProducts, mainProductId);
  //     });

  //     addAllToCartBtnDesktop.setAttribute("listener", "true");
  //   }
  // }
}
function hideAddAllToCartButton() {
  const addAllToCartBtnDesktop = document.querySelector(
    "#continueToCart button"
  );

  if (addAllToCartBtnDesktop) {
    addAllToCartBtnDesktop.style.display = "none";
  }
}
function checkAndDisableButtons(QtyLimit) {
  const selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const totalItemsAdded = selectedProducts.reduce(
    (total, product) => total + product.quantity,
    0
  );

  if (totalItemsAdded >= getQtyLimit()) {
    // Disable all quantity increase buttons
    document.querySelectorAll(".increase-quantity").forEach((button) => {
      button.disabled = true;
    });

    // Disable all add-to-cart buttons
    document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
      button.disabled = true;
    });

    // Optionally, show the 'Add All to Cart' button if limit reached
    showAddAllToCartButton();
  } else {
    // Re-enable buttons if limit is not reached
    document.querySelectorAll(".increase-quantity").forEach((button) => {
      button.disabled = false;
    });

    document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
      button.disabled = false;
    });

    // hideAddAllToCartButton();
  }
  updateChoiceStatus(localStorage.getItem("minimumChoice"));
  updatePremiumAddOnCharges();
}
function attachRemoveItemListeners() {
  // Remove existing listeners to prevent duplicates
  document.querySelectorAll(".remove-item-btn").forEach((button) => {
    button.removeEventListener("click", handleRemoveItem);
  });
  
  document.querySelectorAll(".cart-quantity-minus").forEach((button) => {
    button.removeEventListener("click", handleCartQuantityMinus);
  });
  
  document.querySelectorAll(".cart-quantity-plus").forEach((button) => {
    button.removeEventListener("click", handleCartQuantityPlus);
  });
  
  document.querySelectorAll(".cart-quantity-input").forEach((input) => {
    input.removeEventListener("change", handleCartQuantityInput);
  });

  // Add new event listeners
  document.querySelectorAll(".remove-item-btn").forEach((button) => {
    button.addEventListener("click", handleRemoveItem);
  });

  document.querySelectorAll(".cart-quantity-minus").forEach((button) => {
    button.addEventListener("click", handleCartQuantityMinus);
  });

  document.querySelectorAll(".cart-quantity-plus").forEach((button) => {
    button.addEventListener("click", handleCartQuantityPlus);
  });

  document.querySelectorAll(".cart-quantity-input").forEach((input) => {
    input.addEventListener("change", handleCartQuantityInput);
  });
}

// Separate handler functions to prevent duplicate listeners
function handleRemoveItem(event) {
  const variantId = event.currentTarget.getAttribute("data-variant-id");
  removeProductFromLocalStorage(variantId);
}

function handleCartQuantityMinus(event) {
  event.preventDefault();
  event.stopPropagation();
  
  const variantId = event.currentTarget.getAttribute("data-variant-id");
  const cartItem = event.currentTarget.closest("li[data-variant-id]");
  const quantityInput = cartItem.querySelector(".cart-quantity-input");
  
  if (!quantityInput) return;
  
  let currentQuantity = parseInt(quantityInput.value) || 1;
  
  if (currentQuantity > 1) {
    currentQuantity--;
    quantityInput.value = currentQuantity;
    updateCartItemQuantity(variantId, currentQuantity);
  } else {
    // Remove item if quantity becomes 0
    removeProductFromLocalStorage(variantId);
  }
}

function handleCartQuantityPlus(event) {
  event.preventDefault();
  event.stopPropagation();
  
  const variantId = event.currentTarget.getAttribute("data-variant-id");
  const cartItem = event.currentTarget.closest("li[data-variant-id]");
  const quantityInput = cartItem.querySelector(".cart-quantity-input");
  
  if (!quantityInput) return;
  
  let currentQuantity = parseInt(quantityInput.value) || 1;
  
  // Check inventory limit
  const productCard = document.querySelector(`.grid__item[data-variant-id="${variantId}"]`);
  if (productCard) {
    const addToCartBtn = productCard.querySelector(".custom_addCart");
    const inventory = parseInt(addToCartBtn.getAttribute("data-inventory")) || 999;
    
    if (currentQuantity < inventory) {
      currentQuantity++;
      quantityInput.value = currentQuantity;
      updateCartItemQuantity(variantId, currentQuantity);
    }
  } else {
    // If product card not found, allow increase (fallback)
    currentQuantity++;
    quantityInput.value = currentQuantity;
    updateCartItemQuantity(variantId, currentQuantity);
  }
}

function handleCartQuantityInput(event) {
  const variantId = event.currentTarget.getAttribute("data-variant-id");
  let newQuantity = parseInt(event.currentTarget.value) || 1;
  
  if (newQuantity < 1) {
    newQuantity = 1;
    event.currentTarget.value = newQuantity;
  }
  
  // Check inventory limit
  const productCard = document.querySelector(`.grid__item[data-variant-id="${variantId}"]`);
  if (productCard) {
    const addToCartBtn = productCard.querySelector(".custom_addCart");
    const inventory = parseInt(addToCartBtn.getAttribute("data-inventory")) || 999;
    
    if (newQuantity > inventory) {
      newQuantity = inventory;
      event.currentTarget.value = newQuantity;
    }
  }
  
  updateCartItemQuantity(variantId, newQuantity);
}

function updateCartItemQuantity(variantId, newQuantity) {
  let selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const productIndex = selectedProducts.findIndex(product => product.variantId === variantId);
  
  if (productIndex !== -1) {
    // Update localStorage
    selectedProducts[productIndex].quantity = newQuantity;
    localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
    
    // Update the main product grid quantity input
    const productCard = document.querySelector(`.grid__item[data-variant-id="${variantId}"]`);
    if (productCard) {
      const quantityInput = productCard.querySelector(".quantity__input");
      if (quantityInput) {
        quantityInput.value = newQuantity;
      }
      
      // Update plus button state based on inventory
      const increaseBtn = productCard.querySelector(".quantity__button[name='plus']");
      const addToCartBtn = productCard.querySelector(".custom_addCart");
      if (increaseBtn && addToCartBtn) {
        const inventory = parseInt(addToCartBtn.getAttribute("data-inventory")) || 999;
        if (newQuantity >= inventory) {
          increaseBtn.classList.add("disabled");
        } else {
          increaseBtn.classList.remove("disabled");
        }
      }
    }
    
    // Update cart display - find the cart item and update its display
    // Use more specific selector to target only side cart items, not product cards
    const cartItem = document.querySelector(`#cart-items li[data-variant-id="${variantId}"]`);
    if (cartItem) {
      const quantityInput = cartItem.querySelector(".cart-quantity-input");
      if (quantityInput) {
        quantityInput.value = newQuantity;
      }
      
      // Update pricing dynamically based on quantity
      // Try multiple selectors to find price elements
      const has_premiumPrice = cartItem.querySelector(".premium-price") || cartItem.querySelector("span.premium-price");
      const has_lpPrice = cartItem.querySelector(".lp-price") || cartItem.querySelector("span.lp-price");
      
      if (has_premiumPrice) {
        // Update premium pricing
        const premiumValue = has_premiumPrice.getAttribute("data-premium-Value");
        const final_premium = newQuantity * premiumValue;
        has_premiumPrice.textContent = `$${final_premium}`;
      } else if (has_lpPrice) {
        // For regular products, just show "Free" regardless of quantity
        has_lpPrice.textContent = `Free`;
        
        // Don't update product card prices - keep them as unit prices
      }
    }
    
    // Update choice status and premium charges
    updateChoiceStatus(localStorage.getItem("minimumChoice"));
    updatePremiumAddOnCharges();
    
    // Product card prices remain unchanged - only side cart prices update dynamically
    
    // Check if we should show/hide add to cart button
    const totalItemsAdded = selectedProducts.reduce((total, product) => total + product.quantity, 0);
    const QtyLimit = parseInt(localStorage.getItem("minimumChoice"));
    
    if (totalItemsAdded >= getQtyLimit()) {
      showAddAllToCartButton();
    } else {
      hideAddAllToCartButton();
    }
    
    checkMaximumLimit();
    
    // Update cart count in header
    updateCartCountInHeader();
  }
}

// Product card prices remain static - only side cart prices update dynamically

// Function to update side cart quantity display based on product card changes
function updateSideCartQuantity(variantId, quantity) {
  // Use specific selector to target only side cart items, not product cards
  const cartItem = document.querySelector(`#cart-items li[data-variant-id="${variantId}"]`);
  if (!cartItem) return;

  // Find the quantity input in the side cart
  const quantityInput = cartItem.querySelector(".cart-quantity-input");
  
  if (quantityInput) {
    // Update the quantity display
    quantityInput.value = quantity;
  }
}

// Function to ensure SVG is present in cart icon - ALWAYS FORCE SVG TO BE VISIBLE
function ensureCartIconSVG() {
  const cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart');
  if (cartIcon) {
    const svgWrapper = cartIcon.querySelector('.svg-wrapper');
    if (svgWrapper) {
      // Always ensure SVG is present - check if it's missing or empty
      const hasSVG = svgWrapper.querySelector('svg');
      const selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];
      const totalItems = selectedProducts.reduce((total, product) => total + product.quantity, 0);
      
      // Force SVG to be present regardless of current state
      if (!hasSVG || !svgWrapper.innerHTML.trim()) {
        if (totalItems > 0) {
          svgWrapper.innerHTML = `<svg class="icon icon-cart" width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.25 14.25V8C11.25 5.92893 12.9289 4.25 15 4.25C17.0711 4.25 18.75 5.92893 18.75 8V14.2091M13 26.75H17C19.8003 26.75 21.2004 26.75 22.27 26.205C23.2108 25.7257 23.9757 24.9608 24.455 24.02C25 22.9504 25 21.5503 25 18.75V15.75C25 14.3499 25 13.6498 24.7275 13.115C24.4878 12.6446 24.1054 12.2622 23.635 12.0225C23.1002 11.75 22.4001 11.75 21 11.75H9C7.59987 11.75 6.8998 11.75 6.36502 12.0225C5.89462 12.2622 5.51217 12.6446 5.27248 13.115C5 13.6498 5 14.3499 5 15.75V18.75C5 21.5503 5 22.9504 5.54497 24.02C6.02433 24.9608 6.78924 25.7257 7.73005 26.205C8.79961 26.75 10.1997 26.75 13 26.75Z" stroke="#1F1F1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`;
        } else {
          svgWrapper.innerHTML = `<svg class="icon icon-cart-empty" width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.25 14.25V8C11.25 5.92893 12.9289 4.25 15 4.25C17.0711 4.25 18.75 5.92893 18.75 8V14.2091M13 26.75H17C19.8003 26.75 21.2004 26.75 22.27 26.205C23.2108 25.7257 23.9757 24.9608 24.455 24.02C25 22.9504 25 21.5503 25 18.75V15.75C25 14.3499 25 13.6498 24.7275 13.115C24.4878 12.6446 24.1054 12.2622 23.635 12.0225C23.1002 11.75 22.4001 11.75 21 11.75H9C7.59987 11.75 6.8998 11.75 6.36502 12.0225C5.89462 12.2622 5.51217 12.6446 5.27248 13.115C5 13.6498 5 14.3499 5 15.75V18.75C5 21.5503 5 22.9504 5.54497 24.02C6.02433 24.9608 6.78924 25.7257 7.73005 26.205C8.79961 26.75 10.1997 26.75 13 26.75Z" stroke="#1F1F1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`;
        }
      }
    }
  }
}

// Continuous monitoring to ensure SVG is ALWAYS present
let svgMonitorInterval;

function startSVGMonitoring() {
  // Clear any existing interval
  if (svgMonitorInterval) {
    clearInterval(svgMonitorInterval);
  }
  
  // Check every 500ms to ensure SVG is always present
  svgMonitorInterval = setInterval(ensureCartIconSVG, 500);
}

// Ensure SVG is present when page loads
document.addEventListener('DOMContentLoaded', function() {
  ensureCartIconSVG();
  startSVGMonitoring();
});

// Also ensure SVG is present after delays to catch any dynamic updates
setTimeout(ensureCartIconSVG, 100);
setTimeout(ensureCartIconSVG, 500);
setTimeout(ensureCartIconSVG, 1000);
setTimeout(ensureCartIconSVG, 2000);

// Start monitoring after page is fully loaded
window.addEventListener('load', function() {
  startSVGMonitoring();
  // Force update cart count on page load for pick-and-mix pages
  updateCartCountInHeader();
});

// Also update cart count when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Force update cart count on DOM ready for pick-and-mix pages
  setTimeout(updateCartCountInHeader, 100);
  setTimeout(updateCartCountInHeader, 500);
});

// Function to update cart count in header
function updateCartCountInHeader() {
  const selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const totalItems = selectedProducts.reduce((total, product) => total + product.quantity, 0);
  
  // Ensure SVG is present in cart icon
  ensureCartIconSVG();
  
  // FORCE cart count to be visible when there are items
  if (totalItems > 0) {
    // Find all possible cart count elements
    const cartCountSelectors = [
      '.cart-count-bubble',
      '.cart-count', 
      '[data-cart-count]',
      '#cart-icon-bubble .cart-count-bubble',
      '.header__icon--cart .cart-count-bubble',
      '.cart-link .cart-count-bubble'
    ];
    
    cartCountSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        // Find the span element that should contain the count number
        const countSpan = element.querySelector('span[aria-hidden="true"]');
        if (countSpan) {
          countSpan.textContent = totalItems;
        } else {
          // If no specific span found, update the element but preserve children
          const existingContent = element.innerHTML;
          if (existingContent.includes('<span')) {
            // Preserve existing structure and just update the count
            element.innerHTML = existingContent.replace(/(<span[^>]*aria-hidden="true"[^>]*>)[^<]*(<\/span>)/, `$1${totalItems}$2`);
          } else {
            element.textContent = totalItems;
          }
        }
        element.style.display = 'block';
        element.style.visibility = 'visible';
        element.style.opacity = '1';
      });
    });
    
    // Also ensure the cart count bubble exists if it doesn't
    const cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart');
    if (cartIcon) {
      let cartCountBubble = cartIcon.querySelector('.cart-count-bubble');
      if (!cartCountBubble) {
        // Create cart count bubble if it doesn't exist
        cartCountBubble = document.createElement('div');
        cartCountBubble.className = 'cart-count-bubble';
        cartCountBubble.innerHTML = `<span aria-hidden="true">${totalItems}</span><span class="visually-hidden">${totalItems} items</span>`;
        cartIcon.appendChild(cartCountBubble);
      } else {
        // Update existing cart count bubble
        const countSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
        if (countSpan) {
          countSpan.textContent = totalItems;
        } else {
          cartCountBubble.innerHTML = `<span aria-hidden="true">${totalItems}</span><span class="visually-hidden">${totalItems} items</span>`;
        }
        cartCountBubble.style.display = 'block';
        cartCountBubble.style.visibility = 'visible';
        cartCountBubble.style.opacity = '1';
      }
    }
  } else {
    // Hide cart count when no items
    const cartCountElements = document.querySelectorAll('.cart-count-bubble, .cart-count, [data-cart-count]');
    cartCountElements.forEach(element => {
      const countSpan = element.querySelector('span[aria-hidden="true"]');
      if (countSpan) {
        countSpan.textContent = '';
      } else {
        element.textContent = '';
      }
      element.style.display = 'none';
    });
  }
}

let totalItemsAdded = 0;
function removeProductFromLocalStorage(variantId) {
  let selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const productToRemove = selectedProducts.find(
    (product) => product.variantId === variantId
  );

  if (productToRemove) {
    totalItemsAdded -= productToRemove.quantity;
    if (totalItemsAdded < 0) totalItemsAdded = 0;
    selectedProducts = selectedProducts.filter(
      (product) => product.variantId !== variantId
    );
    localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
    const productCard = document.querySelector(
      `.grid__item[data-variant-id="${variantId}"]`
    );
    if (productCard) {
      const addToCartBtn = productCard.querySelector(".custom_addCart");
      const quantityControls = productCard.querySelector(
        ".custom_cart-quantity"
      );
      const quantityInput = productCard.querySelector(".quantity__input");
      if (addToCartBtn) {
        addToCartBtn.classList.remove("hide_btn");
      } else {
        console.warn("Add to Cart button not found");
      }
      if (quantityControls) {
        quantityControls.classList.add("hide_btn");
      } else {
        console.warn("Quantity controls not found");
      }
      if (quantityInput) {
        quantityInput.value = 1;
      } else {
        console.warn("Quantity input not found");
      }
    } else {
      console.warn(`Product card for variantId ${variantId} not found`);
    }
    removeProductFromCartContainer(variantId);
    checkAndDisableButtons(getQtyLimit());
    updateChoiceStatus(localStorage.getItem("minimumChoice"));
    updatePremiumAddOnCharges();
    // updateTotalPriceDisplay();
    // console.log('after removingggggg selectedProducts',selectedProducts.length);
    let totalQuantity = selectedProducts.reduce(
      (total, product) => total + product.quantity,
      0
    );
    if (totalQuantity < getQtyLimit())
      document.querySelector("#continueToCart button").style.display = "none";
    
    // Update cart count in header
    updateCartCountInHeader();
  } else {
    console.warn(
      `Product with variantId ${variantId} not found in localStorage.`
    );
  }
  checkMaximumLimit();
}
function removeProductFromCartContainer(variantId) {
  const main_cartContainerDesktop = document.getElementById("custom-view_cart");
  const cartContainerDesktop =
    main_cartContainerDesktop.querySelector("#cart-items");
   if (!cartContainerDesktop) return;

  const cartItem = cartContainerDesktop.querySelector(
    `li[data-variant-id="${variantId}"]`
  );

  if (cartItem) {
    cartContainerDesktop.removeChild(cartItem);
  }
  // updateTotalPriceDisplay();
  const mobile_cartContainer = document.getElementById("mv-cl-content");
  if (!mobile_cartContainer) return;
  const mv_cartItem = mobile_cartContainer.querySelector(
    `#cart-items li[data-variant-id="${variantId}"]`
  );

  if (mv_cartItem) {
    // console.log('deskkkk', mobile_cartContainer.querySelector(`#cart-items`))
    mobile_cartContainer.querySelector(`#cart-items`).removeChild(mv_cartItem);
  }
  updatePremiumAddOnCharges();
}

function updateProductQuantityInLocalStorage(variantId, quantity) {
  let selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const product = selectedProducts.find((p) => p.variantId === variantId);

  if (product) {
    product.quantity = quantity;
  }

  localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
  updatePremiumAddOnCharges();
  
  // Update cart count in header
  updateCartCountInHeader();
}
function setupAddToCartButton() {
  const selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  const addAllToCartBtn = document.querySelector("#continueToCart button");
  if (addAllToCartBtn && !addAllToCartBtn.hasAttribute("listener")) {
    addAllToCartBtn.addEventListener("click", () => {
      addAllToCartBtn.disabled = true;
      addMainProductAndBatch(selectedProducts);
    });
    addAllToCartBtn.setAttribute("listener", "true");
  }
}
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
async function addMainProductAndBatch(products) {
  try {
    await addAllToCart(products);
    await delay(1000);
    await batchAddToCartWithRetry(products);
  } catch (error) {
    console.error("Error in addMainProductAndBatch:", error);
  }
}
// async function addToCart() {
//   const selected_styleProduct = localStorage.getItem("selectedStyleProduct");
//   const selected_gid = localStorage.getItem("selectedProductgID");
//   const selected_style =  localStorage.getItem("selectedStyle");
//   const minChoice =  localStorage.getItem("minimumChoice");
//   if (!selected_styleProduct) return;
//   const parentProduct = {
//     _product: true, // Replace with actual key-value pairs
//     _gid: selected_gid,
//     _name: selected_style,
//     _minCount: minChoice,
//   };
//   try {
//     const response = await fetch("/cart/add.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       body: JSON.stringify({
//         id: selected_styleProduct,
//         quantity: 1,
//         properties: parentProduct,
//       }),
//     });

//     if (!response.ok) throw new Error("Failed to add main product to the cart.");
//     const data = await response.json();
//     console.log("Successfully added main product to the cart:", data);
//   } catch (error) {
//     console.error("Error adding main product to cart:", error);
//   }
// }
// async function batchAddToCart(products) {

//   const addToCartBtnDesktop = document.querySelector("#continueToCart button span");
//   if (addToCartBtnDesktop) {
//     addToCartBtnDesktop.textContent = "Adding...";
//     addToCartBtnDesktop.disabled = true;
//   }
//   const itemsToAdd = products.map((product) => {

//     return {
//       id: product.variantId,
//       quantity: product.quantity,
//       properties:{_gid: localStorage.getItem("selectedProductgID"),_tags: product.productTag},
//     };
//   });

//   try {
//     const response = await fetch("/cart/add.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       body: JSON.stringify({ items: itemsToAdd }),
//     });

//     if (!response.ok) throw new Error("Failed to add products to the cart.");
//     // const cartData = await response.json();
//     // console.log("Successfully added products to the cart:", cartData);
//     localStorage.clear();
//     document.getElementById("cart-items").innerHTML = "";

//     if (addToCartBtnDesktop) {
//       addToCartBtnDesktop.textContent = "Go to Cart";
//       // alert("all added");
//       window.location = '/cart?bundle_added';
//       addToCartBtnDesktop.disabled = false;
//     }
//   } catch (error) {
//     console.error("Error adding products to the cart:", error);

//     if (addToCartBtnDesktop) {
//       addToCartBtnDesktop.textContent = "Add to Cart";
//       addToCartBtnDesktop.disabled = false;
//     }
//   }
// }

async function addAllToCart(products) {
  const selected_styleProduct = localStorage.getItem("selectedStyleProduct");
  const selected_gid = localStorage.getItem("selectedProductgID");
  const selected_style = localStorage.getItem("selectedStyle");
  const minChoice = localStorage.getItem("minimumChoice");

  const addToCartBtnDesktop = document.querySelector("#continueToCart button");
  if (addToCartBtnDesktop) {
    addToCartBtnDesktop.textContent = "Adding...";
    addToCartBtnDesktop.disabled = true;
  }

  // Build the main product item
  const mainProductItem = selected_styleProduct
    ? {
        id: selected_styleProduct,
        quantity: 1,
        properties: {
          _product: true,
          _gid: selected_gid,
          _name: selected_style,
          _minCount: minChoice,
        },
      }
    : null;

  // Build bundle items
  const bundleItems = products.map((product) => ({
    id: product.variantId,
    quantity: product.quantity,
    properties: {
      _gid: selected_gid,
      _tags: product.productTag,
    },
  }));

  // Combine main + bundle (if main product exists)
  const itemsToAdd = mainProductItem
    ? [mainProductItem, ...bundleItems]
    : [...bundleItems];

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: itemsToAdd }),
    });

    const data = await response.json();

    if (!response.ok) {
      const errorMessage =
        data.description || data.message || "This product is already sold out";
      alert(errorMessage);
      if (addToCartBtnDesktop) {
        addToCartBtnDesktop.textContent = "Add to Cart";
        addToCartBtnDesktop.disabled = false;
      }
      return;
    }

    localStorage.clear();
    document.getElementById("cart-items").innerHTML = "";
    
    // Update cart count in header after clearing
    updateCartCountInHeader();

    if (addToCartBtnDesktop) {
      addToCartBtnDesktop.textContent = "Go to Cart";
      // window.location = "/cart?bundle_added";
      window.location.replace("/cart?bundle_added");
      addToCartBtnDesktop.disabled = false;
    }
  } catch (error) {
    console.error("Error adding products to the cart:", error);
    if (addToCartBtnDesktop) {
      addToCartBtnDesktop.textContent = "Add to Cart";
      addToCartBtnDesktop.disabled = false;
    }
  }
}

async function batchAddToCartWithRetry(products, maxRetries = 2) {
  let attempts = 0;
  while (attempts < maxRetries) {
    try {
      await addAllToCart(products);
      return;
    } catch (error) {
      attempts++;
      console.error(`Retrying batchAddToCart, Attempt: ${attempts}`);
      await delay(1000);
    }
  }
  console.error("Failed to add child products after multiple attempts.");
}
document
  .querySelector(".custom_surprise-me-btn")
  ?.addEventListener("click", () => {
    ensureSufficientProducts();
  });
// function ensureSufficientProducts() {
//   const productLimitSurprise = localStorage.getItem("minimumChoice");

//   let MAX_CHOICES = parseInt(productLimitSurprise, 10);
//   // if (productLimitSurprise && productLimitSurprise.includes("x")) {
//   //   MAX_CHOICES = parseInt(productLimitSurprise.split("x")[1].trim(), 10);
//   // } else {
//   //   MAX_CHOICES = parseInt(productLimitSurprise, 10);
//   // }

//   const availableProducts = getAvailableProducts();
//   console.log(availableProducts)

//   let selectedProducts =
//     JSON.parse(localStorage.getItem("selectedProducts")) || [];
//   let totalQuantity = selectedProducts.reduce(
//     (total, product) => total + product.quantity,
//     0
//   );
//   let remainingChoices = MAX_CHOICES - totalQuantity;

//   if (remainingChoices <= 0) {
//     alert("No more products needed.");
//     return;
//   }

//   if (availableProducts.length === 0) {
//     console.warn("No available products to choose from.");
//     return;
//   }
//   // Filter products that still have inventory left
//   let eligibleProducts = availableProducts.filter(product => {
//     const inCart = selectedProducts.find(p => p.variantId === product.variantId)?.quantity || 0;
//     return inCart < product.inventory;
//   });
//   // Shuffle the available products randomly
//   eligibleProducts.sort(() => 0.5 - Math.random());
//   const productsToAdd = [];

//   function addProduct(product, quantity) {
//     productsToAdd.push({
//       variantId: product.variantId,
//       title: product.title,
//       image: product.image,
//       price: product.price,
//       quantity: quantity,
//       productId: product.productId,
//       productTag: product.productTag
//     });
//   }

//   // **STEP 1: Add one of each product first (if inventory allows)**
//   eligibleProducts.forEach((product) => {
//     if (remainingChoices <= 0) return;
//     const inCart = selectedProducts.find(p => p.variantId === product.variantId)?.quantity || 0;
//     const availableStock = product.inventory - inCart;
//     if (availableStock > 0) {
//         addProduct(product, 1); // Always add **only 1 at a time**
//         remainingChoices -= 1;
//     }
//   });

//    // **STEP 2: Distribute remaining choices across products fairly**
//   let i = 0;
//   while (remainingChoices > 0 && eligibleProducts.length > 0) {
//       const product = eligibleProducts[i % eligibleProducts.length];
//       const inCart = selectedProducts.find(p => p.variantId === product.variantId)?.quantity || 0;
//       const alreadyAdded = productsToAdd.filter(p => p.variantId === product.variantId)
//           .reduce((sum, p) => sum + p.quantity, 0);
//       const availableStock = product.inventory - inCart - alreadyAdded;
//       if (availableStock > 0) {
//           addProduct(product, 1); // Add **only 1 at a time**
//           remainingChoices -= 1;
//       }
//       i++;
//   }

//   addProductsToLocalStorage(productsToAdd);
//   updateChoiceStatus(localStorage.getItem("minimumChoice"));
//      // **STEP 3: Update Plus Button UI Only for Added Products**
//      productsToAdd.forEach(({ variantId, quantity }) => {
//       const productCard = document.querySelector(`.grid__item[data-variant-id="${variantId}"]`);
//       if (!productCard) return;

//       const quantityInput = productCard.querySelector(".quantity__input");
//       const increaseBtn = productCard.querySelector(".quantity__button[name='plus']");
//       const inventory = parseInt(productCard.querySelector('.custom_addCart').getAttribute('data-inventory'), 10);

//       // Fetch the updated quantity from localStorage
//       selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];
//       let updatedProduct = selectedProducts.find(p => p.variantId === variantId);
//       let currentQuantity = updatedProduct ? updatedProduct.quantity : 0;
//       console.log('inventory',inventory);
//       console.log('currentQuantity',currentQuantity);
//       if (quantityInput) {
//           quantityInput.value = currentQuantity;
//       }

//       if (increaseBtn) {
//           if (currentQuantity >= inventory) {
//               increaseBtn.classList.add('disabled');
//           } else {
//               increaseBtn.classList.remove('disabled');
//           }
//       }
//   });
// }

async function ensureSufficientProducts() {
  const productLimitSurprise = localStorage.getItem("minimumChoice");

  let MAX_CHOICES = parseInt(productLimitSurprise, 10);
  const MAX_LINE_ITEMS = 35;
  try {
    const response = await fetch('/cart.js');
    const cartData = await response.json();
    const remainingLineItems = MAX_LINE_ITEMS - cartData.items.length;
    // Set MAX_CHOICES based on available slots
    MAX_CHOICES = parseInt(productLimitSurprise) <= remainingLineItems ? 
                  parseInt(productLimitSurprise) : 
                  remainingLineItems;
  } catch (error) {
    console.error('Error fetching cart:', error);
    // Fallback to using productLimitSurprise if cart fetch fails
  }

  const availableProducts = getAvailableProducts();
 
  let selectedProducts =
    JSON.parse(localStorage.getItem("selectedProducts")) || [];
  let totalQuantity = selectedProducts.reduce(
    (total, product) => total + product.quantity,
    0
  );
  let remainingChoices = MAX_CHOICES - totalQuantity;

  if (remainingChoices <= 0) {
    alert("No more products needed.");
    return;
  }

  if (availableProducts.length === 0) {
    console.warn("No available products to choose from.");
    return;
  }

  // Filter products that still have inventory left
  let eligibleProducts = availableProducts.filter((product) => {
    const inCart =
      selectedProducts.find((p) => p.variantId === product.variantId)
        ?.quantity || 0;
    return inCart < product.inventory;
  });

  if (eligibleProducts.length === 0) {
    console.warn("No products with remaining inventory.");
    return;
  }

  // Shuffle the available products randomly
  eligibleProducts.sort(() => 0.5 - Math.random());
  const productsToAdd = [];

  function addProduct(product, quantity) {
    productsToAdd.push({
      variantId: product.variantId,
      title: product.title,
      image: product.image,
      price: product.price,
      quantity: quantity,
      productId: product.productId,
      productTag: product.productTag,
    });
  }

  // Calculate total available inventory across all products
  const totalAvailableInventory = eligibleProducts.reduce((total, product) => {
    const inCart =
      selectedProducts.find((p) => p.variantId === product.variantId)
        ?.quantity || 0;
    return total + (product.inventory - inCart);
  }, 0);

  // If total available inventory is less than remaining choices, use what we have
  const actualChoicesToAdd = Math.min(
    remainingChoices,
    totalAvailableInventory
  );
  let choicesAdded = 0;

  // First pass: try to distribute evenly
  while (choicesAdded < actualChoicesToAdd && eligibleProducts.length > 0) {
    // Keep going through products in a round-robin fashion
    for (
      let i = 0;
      i < eligibleProducts.length && choicesAdded < actualChoicesToAdd;
      i++
    ) {
      const product = eligibleProducts[i];
      const inCart =
        selectedProducts.find((p) => p.variantId === product.variantId)
          ?.quantity || 0;
      const alreadyAdded = productsToAdd
        .filter((p) => p.variantId === product.variantId)
        .reduce((sum, p) => sum + p.quantity, 0);

      const remainingInventory = product.inventory - inCart - alreadyAdded;

      if (remainingInventory > 0) {
        // Add one at a time to ensure even distribution when possible
        addProduct(product, 1);
        choicesAdded++;
      }

      // If we've used all this product's inventory, remove it from eligibleProducts
      if (remainingInventory <= 1) {
        eligibleProducts.splice(i, 1);
        i--; // Adjust index since we removed an element
      }
    }

    // If we've gone through all products and still have choices to add,
    // but no more products have inventory, break out
    if (eligibleProducts.length === 0) break;
  }

  addProductsToLocalStorage(productsToAdd);
  updateChoiceStatus(localStorage.getItem("minimumChoice"));
  updatePremiumAddOnCharges();
  // Update Plus Button UI Only for Added Products
  productsToAdd.forEach(({ variantId }) => {
    const productCard = document.querySelector(
      `.grid__item[data-variant-id="${variantId}"]`
    );
    if (!productCard) return;

    const quantityInput = productCard.querySelector(".quantity__input");
    const increaseBtn = productCard.querySelector(
      ".quantity__button[name='plus']"
    );
    const inventory = parseInt(
      productCard
        .querySelector(".custom_addCart")
        .getAttribute("data-inventory"),
      10
    );

    // Fetch the updated quantity from localStorage
    selectedProducts =
      JSON.parse(localStorage.getItem("selectedProducts")) || [];
    let updatedProduct = selectedProducts.find(
      (p) => p.variantId === variantId
    );
    let currentQuantity = updatedProduct ? updatedProduct.quantity : 0;

    if (quantityInput) {
      quantityInput.value = currentQuantity;
    }

    if (increaseBtn) {
      if (currentQuantity >= inventory) {
        increaseBtn.classList.add("disabled");
      } else {
        increaseBtn.classList.remove("disabled");
      }
    }
  });
}

  function getAvailableProducts() {
    const products = [];
  
    document.querySelectorAll(".grid__item[data-variant-id]").forEach((productCard) => {
      const variantId = productCard.getAttribute("data-variant-id");
      const productId = productCard.getAttribute("data-product-id");
      const productTag = productCard.getAttribute("data-product-tags");
      const title = productCard
        .querySelector(".card__heading a")
        ?.textContent.trim();
      const image = productCard
        .querySelector(".card__media img")
        ?.getAttribute("srcset");
      const quantity = parseInt(
        productCard.querySelector(".quantity__input")?.value || "0",
        10
      );
      let priceElement = productCard.querySelector(".price__container span.price-item.price-item--regular");

      // Get price from admin data instead of DOM
      let price = 0;
      for (const id in window.productsData) {
        const product = window.productsData[id];
        const variant = product.variants.find((v) => v.variantId === variantId);
        if (variant) {
          const priceInCents = parseInt(variant.price);
          price = priceInCents / 100;
          console.log(`Admin price for ${variantId}: ${price} (from ${priceInCents} cents)`);
          break;
        }
      }
      const addCartBtn = productCard.querySelector('.custom_addCart');
      const isSoldOut = addCartBtn && addCartBtn.hasAttribute('data-sold-out-message');
      const inventory = parseInt(addCartBtn?.getAttribute('data-inventory') || '0');
      const isInStock = !isSoldOut && inventory > 0;
      if (variantId && title && image && isInStock) {
        products.push({
          variantId: variantId,
          title: title,
          image: image,
          price: price,
          quantity: quantity,
          productId: productId,
          productTag: productTag,
          inventory:inventory
        });
      }
    });
    return products;
  }
  function addProductsToLocalStorage(products) {
    let selectedProducts =
      JSON.parse(localStorage.getItem("selectedProducts")) || [];
  
    products.forEach((product) => {
      const existingProduct = selectedProducts.find(
        (p) => p.variantId === product.variantId
      );
  
      if (existingProduct) {
        existingProduct.quantity += product.quantity;
      } else {
        selectedProducts.push({
          variantId: product.variantId,
          title: product.title,
          image: product.image,
          price: product.price,
          quantity: product.quantity,
          productId: product.productId,
          inventory: product.inventory,
          productTag: product.productTag 
        });
      }
    });
  
    localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
    updateUIAfterSurpriseMe();
    
    // Update cart count in header
    updateCartCountInHeader();
  }
  function updateUIAfterSurpriseMe() {
    const productLimitSurprise = localStorage.getItem("minimumChoice");
    let MAX_CHOICES = parseInt(productLimitSurprise, 10);

  
    const selectedProducts =
      JSON.parse(localStorage.getItem("selectedProducts")) || [];
    const totalItemsAdded = selectedProducts.reduce(
      (total, product) => total + product.quantity,
      0
    );
    // const remainingChoices = MAX_CHOICES - totalItemsAdded;
    // const choiceStatusDesktop = document.getElementById("choice-status");
    // const choiceStatusMobile = document.getElementById("choice-status-mobile");
    // const priceDisplayDesktop = document.getElementById("priceDisplay");
    // const priceDisplayMobile = document.getElementById("priceDisplayMobile");
    // const continueToCartButton = document.getElementById("continueToCart");
    // const continueToCartButtonMobile = document.getElementById(
    //   "continueToCartMobile"
    // );
    // if (remainingChoices > 0) {
    //   if (choiceStatusDesktop)
    //     choiceStatusDesktop.innerHTML = `<span>${remainingChoices}</span> choices left!`;
    //   if (choiceStatusMobile)
    //     choiceStatusMobile.innerHTML = `<span>${remainingChoices}</span> choices left!`;
    //   if (priceDisplayDesktop) priceDisplayDesktop.style.display = "none";
    //   if (priceDisplayMobile) priceDisplayMobile.style.display = "none";
    //   if (continueToCartButton) continueToCartButton.style.display = "none";
    //   if (continueToCartButtonMobile)
    //     continueToCartButtonMobile.style.display = "none";
    // } else {
    //   if (choiceStatusDesktop) choiceStatusDesktop.style.display = "none";
    //   if (choiceStatusMobile) choiceStatusMobile.style.display = "none";
    //   if (priceDisplayDesktop) priceDisplayDesktop.style.display = "block";
    //   if (priceDisplayMobile) priceDisplayMobile.style.display = "block";
    //   if (continueToCartButton) continueToCartButton.style.display = "block";
    //   if (continueToCartButtonMobile)
    //     continueToCartButtonMobile.style.display = "block";
    // }
    selectedProducts.forEach((product) => {
      const productCard = document.querySelector(
        `.grid__item[data-variant-id="${product.variantId}"]`
      );
      if (productCard) {
        const quantityInput = productCard.querySelector(".quantity__input");
        const addToCartBtn = productCard.querySelector(".custom_addCart");
        const quantityControls = productCard.querySelector(".custom_cart-quantity");
        if (quantityInput) {
          quantityInput.value = product.quantity;
          // quantityInput.disabled = true;
        }
        if (addToCartBtn) {
          addToCartBtn.classList.add('hide_btn');
          // addToCartBtn.disabled = true;
        }
        if (quantityControls) {
          quantityControls.classList.remove('hide_btn');
        }
        
        // Update side cart quantity display
        updateSideCartQuantity(product.variantId, product.quantity);
      }
    });
    if (totalItemsAdded >= MAX_CHOICES) {
      showAddAllToCartButton();
    }
    // if (totalItemsAdded >= MAX_CHOICES) {
    //   document.querySelectorAll(".increase-quantity").forEach((button) => {
    //     button.disabled = true;
    //   });
    //   document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
    //     button.disabled = true;
    //   });
    //   showAddAllToCartButton();
    // } else {
    //   document.querySelectorAll(".increase-quantity").forEach((button) => {
    //     button.disabled = false;
    //   });
    //   document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
    //     button.disabled = false;
    //   });
    //   hideAddAllToCartButton();
    // }
  
    updateCartContainerAfterSurpriseMe();
    // setupAddToCartButton();
    checkMaximumLimit();
    
    // Update cart count in header
    updateCartCountInHeader();
  }
  function updateCartContainerAfterSurpriseMe() {
    const selectedProducts =
      JSON.parse(localStorage.getItem("selectedProducts")) || [];
    const cartContainerDesktop = document.getElementById("cart-items");
  
    cartContainerDesktop.innerHTML = "";
  
    selectedProducts.forEach((product) => {
      const { image, title, quantity, variantId, price, productId , productTag } = product;
      let price_vari = ``;
      if(productTag?.includes('premium-')){
        const premiumValue = productTag .split(',').map(tag => tag.trim()).filter(tag => tag.startsWith('premium-')).map(tag => tag.replace('premium-', ''));
        const qtyBasePremiumValue = quantity * premiumValue;
        price_vari = `<div class="price-wrap"><span class="premium-price" data-premium-Value="${premiumValue}">$${qtyBasePremiumValue}</span></div>`;
      }else{
        const totalPrice = price * quantity;
        price_vari = `<div class="price-wrap"><span class="lp-price" data-base-price="${price}">Free</span></div>`;
      }
      const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
      <path d="M1 4H17M13 4L12.7294 3.18807C12.4671 2.40125 12.3359 2.00784 12.0927 1.71698C11.8779 1.46013 11.6021 1.26132 11.2905 1.13878C10.9376 1 10.523 1 9.69357 1H8.30643C7.47705 1 7.06236 1 6.70951 1.13878C6.39792 1.26132 6.12208 1.46013 5.90729 1.71698C5.66405 2.00784 5.53292 2.40125 5.27064 3.18807L5 4M15 4V14.2C15 15.8802 15 16.7202 14.673 17.362C14.3854 17.9265 13.9265 18.3854 13.362 18.673C12.7202 19 11.8802 19 10.2 19H7.8C6.11984 19 5.27976 19 4.63803 18.673C4.07354 18.3854 3.6146 17.9265 3.32698 17.362C3 16.7202 3 15.8802 3 14.2V4M11 8V15M7 8V15" stroke="#1F1F1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
        `;
  
      const cartItemHTML = `
      <li class="cart-item" data-variant-id="${variantId}" data-product-id="${productId}" data-product-tags="${productTag}">
      <div class="img-wrap">
          <img src="${image}" alt="${title}" width="80">
      </div>
      <div class="cart-item-details">
          <div class="lp-title">${title}</div>
          <div class="qty-price-wrap">
              <div class="custom-qty-btn-wrap">
                  <div class="custom_cart-quantity cart-quantity">
                      <button class="quantity__button cart-quantity-minus" data-variant-id="${variantId}" name="minus" type="button">
                          <span class="visually-hidden">Decrease quantity</span>
                          <span class="svg-wrapper">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                  <path d="M3.5 7H10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                          </span>
                      </button>
                      <input class="quantity__input cart-quantity-input" data-variant-id="${variantId}" type="number" value="${quantity}" min="1" aria-label="Quantity">
                      <button class="quantity__button cart-quantity-plus" data-variant-id="${variantId}" name="plus" type="button">
                          <span class="visually-hidden">Increase quantity</span>
                          <span class="svg-wrapper">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                  <path d="M7 3.5V10.5M3.5 7H10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                          </span>
                      </button>
                  </div>
              </div>
              ${price_vari}
          </div>
      </div>
      <div class="cartQuantityRemove">
          <div class="remove-item-btn" data-variant-id="${variantId}">${svgIcon}</div>
      </div>
    </li>
  `;
      cartContainerDesktop.innerHTML += cartItemHTML;
    });
  
    attachRemoveItemListeners();
    
    // Update cart count in header
    updateCartCountInHeader();
  }
  function updateChoiceStatus(maxSelections) {
    const totalItemsAdded = JSON.parse(
      localStorage.getItem("selectedProducts") || "[]"
    ).reduce((total, product) => total + product.quantity, 0);
    const remainingChoices = maxSelections - totalItemsAdded;
  
    // console.log(`Updated Choices Status. Total Items Added: ${totalItemsAdded}`);
    // console.log(`Updated Choices Status. Remaining Choices: ${remainingChoices}`);
  
    const choiceStatusDesktop = document.getElementById("choice-status");
    const choiceStatusMobile = document.getElementById("cart-list-mobile");

    if (remainingChoices > 0) {
      if (choiceStatusDesktop) {
        choiceStatusDesktop.innerHTML = `Add <strong>${remainingChoices}</strong> more picks to checkout.`;
        choiceStatusDesktop.style.display = "block";
        choiceStatusDesktop.closest('.cvc-header-wrap').querySelector('.extra-add-on').style.display = "none";
      }
      if (choiceStatusMobile) {
        choiceStatusMobile.querySelector('.mv-cl-heading span').innerHTML = `${totalItemsAdded}`;
        choiceStatusMobile.querySelector('.mv-cl-count-text').innerHTML = `Add <strong>${remainingChoices}</strong> more picks to checkout.`;
        choiceStatusMobile.querySelector('.mv-cl-count-text').style.display = 'block';
      }
    }
    else {
      if (choiceStatusDesktop) {
        choiceStatusDesktop.style.display = "none";
        const extraAddOn = choiceStatusDesktop.closest('.cvc-header-wrap').querySelector('.extra-add-on');
        if (remainingChoices <= 0) {
          const addOnValue = parseFloat(localStorage.getItem("selectedStyleAddOn") * (totalItemsAdded - maxSelections)).toFixed(2);
          extraAddOn.querySelector('span').innerHTML = `$${addOnValue}`;
          extraAddOn.style.display = "block";
        } else {
          extraAddOn.style.display = "none";
        }
      }
      if (choiceStatusMobile) {
        choiceStatusMobile.querySelector('.mv-cl-heading span').innerHTML = `${totalItemsAdded}`;
        choiceStatusMobile.querySelector('.mv-cl-count-text').style.display = 'none';
      }
    }
  }
/*
async function checkMaximumLimit() {
  try {
    // Get local selected products
    const selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];
    const totalLocalItems = selectedProducts.reduce((total, product) => total + product.quantity, 0);
    const minimumChoice = parseInt(localStorage.getItem("minimumChoice")) || 0;
    const maxTotalLimit = 35;
    
    // Fetch current cart data
    const response = await fetch('/cart.js');
    const cartData = await response.json();
    
    // Count existing line items with _gid property in cart
    const existingBundleItems = cartData.items.filter(item => 
      item.properties && item.properties._gid
    );
    const existingBundleCount = existingBundleItems.length;
    
    // Calculate available slots for new bundle items
    const availableSlots = maxTotalLimit - existingBundleCount;
    
    console.log('Bundle Limit Analysis:', {
      maxTotalLimit,
      existingBundleCount,
      availableSlots,
      totalLocalItems,
      minimumChoice,
      canAddBundle: availableSlots >= minimumChoice
    });
    
    const headerWrap = document.querySelector('.cvc-header-wrap');
    const mainHeading = headerWrap?.querySelector('.cvc-main-heading');
    let existingMessage = headerWrap?.querySelector('.bundle-limit-message');
    
    // Remove existing message first
    if (existingMessage) {
      existingMessage.remove();
      existingMessage = null;
    }
    
    // Remove all limit-related classes first
    document.body.classList.remove('bundle-limit-reached', 'cart-bundle-limit-reached', 'no-bundle-available');
    
    // Check different scenarios
    if (availableSlots <= 0) {
      // No slots available at all
      document.body.classList.add('no-bundle-available');
      
      if (mainHeading) {
        const limitMessage = document.createElement('div');
        limitMessage.className = 'bundle-limit-message';
        limitMessage.style.cssText = 'color: #ff4444; font-size: 14px; margin-top: 5px; font-weight: 500;';
        limitMessage.textContent = 'No more bundles can be added. Cart limit reached.';
        mainHeading.parentNode.insertBefore(limitMessage, mainHeading.nextSibling);
      }
    } else if (availableSlots < minimumChoice) {
      // Available slots are less than minimum required
      document.body.classList.add('no-bundle-available');
      
      if (mainHeading) {
        const limitMessage = document.createElement('div');
        limitMessage.className = 'bundle-limit-message';
        limitMessage.style.cssText = 'color: #ff4444; font-size: 14px; margin-top: 5px; font-weight: 500;';
        limitMessage.textContent = `No more bundles can be added. Only ${availableSlots} slots available, but ${minimumChoice} required.`;
        mainHeading.parentNode.insertBefore(limitMessage, mainHeading.nextSibling);
      }
    } else if (totalLocalItems >= availableSlots) {
      // Local items have reached available limit
      document.body.classList.add('bundle-limit-reached');
      
      if (mainHeading) {
        const limitMessage = document.createElement('div');
        limitMessage.className = 'bundle-limit-message';
        limitMessage.style.cssText = 'color: #ff4444; font-size: 14px; margin-top: 5px; font-weight: 500;';
        limitMessage.textContent = `Maximum bundle limit reached. (${availableSlots} available)`;
        mainHeading.parentNode.insertBefore(limitMessage, mainHeading.nextSibling);
      }
    } else if (totalLocalItems >= minimumChoice && (availableSlots - totalLocalItems) <= 2) {
      // Approaching limit warning
      document.body.classList.add('bundle-approaching-limit');
      
      if (mainHeading) {
        const limitMessage = document.createElement('div');
        limitMessage.className = 'bundle-limit-message';
        limitMessage.style.cssText = 'color: #ff8800; font-size: 14px; margin-top: 5px; font-weight: 500;';
        limitMessage.textContent = `${availableSlots - totalLocalItems} slots remaining.`;
        mainHeading.parentNode.insertBefore(limitMessage, mainHeading.nextSibling);
      }
    }
    
    // Update available slots for UI display if needed
    // if (window.updateAvailableSlotsUI) {
    //   window.updateAvailableSlotsUI(availableSlots, totalLocalItems);
    // }
    
    return {
      availableSlots,
      totalLocalItems,
      canAddMore: totalLocalItems < availableSlots && availableSlots >= minimumChoice,
      canAddBundle: availableSlots >= minimumChoice
    };
    
  } catch (error) {
    console.error('Error checking maximum limit:', error);
    // Remove classes on error to be safe
    document.body.classList.remove('bundle-limit-reached', 'cart-bundle-limit-reached', 'no-bundle-available');
    return {
      availableSlots: 0,
      totalLocalItems: 0,
      canAddMore: false,
      canAddBundle: false
    };
  }
}
*/
/* working code before */
async function checkMaximumLimit() {
  try {
    const MAX_LINE_ITEMS = 35;
    
    // Get current cart state
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();
    
    // Count all line items in cart
    const totalLineItemsInCart = cartData.items.length;
    
    // Get current selected products
    const selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];
    const uniqueLocalItems = selectedProducts.length;
    const minimumChoice = parseInt(localStorage.getItem("minimumChoice")) || 0;
    // Calculate total quantity of selected products
      const totalSelectedQuantity = selectedProducts.reduce((total, product) => total + product.quantity, 0);

    // Calculate available slots
    const availableSlots = MAX_LINE_ITEMS - totalLineItemsInCart;
    
    // Update UI based on availability
    const messageContainer = document.querySelector('.bundle-limit-message') || createMessageContainer();
    
    if (availableSlots <= 0 || totalSelectedQuantity == 0 && availableSlots <= 3) {
      // No slots available
      document.body.classList.add('bundle-limit-reached');
      updateMessage(messageContainer, 'Maximum number of items reached in cart.', 'error');
      disableAddButtons(true);
      hideAddAllToCartButton();
    } 
   /* else if (availableSlots <= 3) {
      // Limited slots available
      document.body.classList.add('bundle-limited');
      updateMessage(messageContainer, `Only ${availableSlots} slots available.`, 'warning');
      updateAddButtonStates(uniqueLocalItems, availableSlots);
      
      // Show add to cart if minimum items selected
      if (totalSelectedQuantity >= minimumChoice) {
        showAddAllToCartButton();
      } else {
        hideAddAllToCartButton();
      }
    } */
    else {
      // Slots available
      document.body.classList.remove('bundle-limit-reached', 'bundle-limited');
      if (messageContainer) messageContainer.style.display = 'none';
      updateAddButtonStates(uniqueLocalItems, availableSlots, totalSelectedQuantity);
      
      // Show add to cart if minimum items selected
      if (totalSelectedQuantity >= minimumChoice) {
        showAddAllToCartButton();
      } else {
        hideAddAllToCartButton();
      }
    }

  } catch (error) {
    console.error('Error checking bundle limit:', error);
    const messageContainer = document.querySelector('.bundle-limit-message') || createMessageContainer();
    updateMessage(messageContainer, 'Unable to verify bundle availability.', 'error');
  }
}

function createMessageContainer() {
  const headerWrap = document.querySelector('.cvc-header-wrap');
  if (!headerWrap) return null;

  const messageContainer = document.createElement('div');
  messageContainer.className = 'bundle-limit-message';
  
  const mainHeading = headerWrap.querySelector('.cvc-main-heading');
  if (mainHeading) {
    headerWrap.insertBefore(messageContainer, mainHeading.nextSibling);
  } else {
    headerWrap.appendChild(messageContainer);
  }
  
  return messageContainer;
}

function updateMessage(container, message, type) {
  if (!container) return;
  
  const colors = {
    error: '#ff4444',
    warning: '#ff8800',
    info: '#1F1F1F',
    success: '#4caf50'
  };
  
  container.style.cssText = `color: ${colors[type]}; font-size: 14px; margin-top: 5px; font-weight: 500;`;
  container.textContent = message;
}

function updateAddButtonStates(uniqueLocalItems, availableSlots, totalSelectedQuantity) {
  // Handle add buttons - excluding sold out products
  document.querySelectorAll('.custom_addCart').forEach(button => {
    const productCard = button.closest('.grid__item');
    if (!productCard) return;

    const variantId = productCard.getAttribute('data-variant-id');
    const isSoldOut = button.hasAttribute('data-sold-out-message');
    const isAlreadyInCart = isProductInLocalStorage(variantId);

    // Don't modify sold out products
    if (isSoldOut) return;

    // Only disable if we've reached 35 total picks and item isn't in cart
    if (totalSelectedQuantity >= 35 && !isAlreadyInCart) {
      button.classList.add('disabled');
      button.setAttribute('disabled', 'disabled');
    } else if (!isAlreadyInCart) {
      button.classList.remove('disabled');
      button.removeAttribute('disabled');
    }
  });

  // Update quantity buttons - only based on inventory
  document.querySelectorAll('.quantity__button').forEach(button => {
    const productCard = button.closest('.grid__item');
    if (!productCard) return;

    const quantityInput = productCard.querySelector('.quantity__input');
    const addToCartBtn = productCard.querySelector('.custom_addCart');
    if (!quantityInput || !addToCartBtn) return;

    // Only check inventory for quantity buttons
    const inventory = parseInt(addToCartBtn.getAttribute('data-inventory') || '0');
    const currentQty = parseInt(quantityInput.value || '0');
    const isSoldOut = addToCartBtn.hasAttribute('data-sold-out-message');

    // Don't modify sold out products' quantity buttons
    if (isSoldOut) return;

    if (button.getAttribute('name') === 'plus') {
      if (currentQty >= inventory) {
        button.classList.add('disabled');
        button.setAttribute('disabled', 'disabled');
      } else {
        button.classList.remove('disabled');
        button.removeAttribute('disabled');
      }
    }
  });

  // Update surprise me button
  const surpriseButton = document.querySelector('.custom_surprise-me-btn');
  if (surpriseButton) {
    if (uniqueLocalItems >= availableSlots) {
      surpriseButton.classList.add('disabled');
      surpriseButton.setAttribute('disabled', 'disabled');
    } else {
      surpriseButton.classList.remove('disabled');
      surpriseButton.removeAttribute('disabled');
    }
  }
}

function disableAddButtons(disabled) {
  // Only handle non-sold-out add buttons
  document.querySelectorAll('.custom_addCart').forEach(button => {
    if (button.hasAttribute('data-sold-out-message')) return;

    if (disabled) {
      button.classList.add('disabled');
      button.setAttribute('disabled', 'disabled');
    } else {
      button.classList.remove('disabled');
      button.removeAttribute('disabled');
    }
  });

  // Handle surprise me button
  const surpriseButton = document.querySelector('.custom_surprise-me-btn');
  if (surpriseButton) {
    if (disabled) {
      surpriseButton.classList.add('disabled');
      surpriseButton.setAttribute('disabled', 'disabled');
    } else {
      surpriseButton.classList.remove('disabled');
      surpriseButton.removeAttribute('disabled');
    }
  }
}

function isProductInLocalStorage(variantId) {
  const selectedProducts = JSON.parse(localStorage.getItem("selectedProducts")) || [];
  return selectedProducts.some(product => product.variantId === variantId);
}
